import { PresetTableCell } from './PresetTableCell';
import type { SetTableViewProps } from './useSeededKidSetTable';
import {
  presetTableBase,
  presetTableCellBase,
  presetTableHeaderCellBase,
} from './useTableStyles';

/**
 * Costs Over Time preset table (presentational).
 * Marker-injected cells (FIG total_cost_* / riy_*, FUND currency / holding period) are read-only.
 */
export function CostsOverTimeTable({
  content,
  updateCell,
  isInjectedCell,
}: SetTableViewProps) {
  const [headerRow, ...dataRows] = content;

  return (
    <table className={presetTableBase}>
      <colgroup>
        <col style={{ width: '40%' }} />
        <col style={{ width: '30%' }} />
        <col style={{ width: '30%' }} />
      </colgroup>
      <thead>
        <tr>
          {headerRow.map((cell, cellIndex) => (
            <th
              key={cellIndex}
              className={`${presetTableHeaderCellBase} text-left`}
            >
              <PresetTableCell
                value={cell}
                rowIndex={0}
                colIndex={cellIndex}
                isInjected={isInjectedCell(0, cellIndex)}
                onUpdate={updateCell}
                multiline={cellIndex === 0}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataRows.map((row, rowIndex) => {
          const formRowIndex = rowIndex + 1;

          return (
            <tr key={formRowIndex}>
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className={`${presetTableCellBase} ${cellIndex === 0 && rowIndex === 0 ? 'font-semibold' : ''}`}
                >
                  <PresetTableCell
                    value={cell}
                    rowIndex={formRowIndex}
                    colIndex={cellIndex}
                    isInjected={isInjectedCell(formRowIndex, cellIndex)}
                    onUpdate={updateCell}
                    multiline={cellIndex === 0}
                  />
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
